import { PERSONA_DELETE_MESSAGES, personaDeletionMessage } from "@shared/persona-deletion";

export async function deleteFailedPersona(id: string): Promise<void> {
  try {
    const response = await fetch(`/api/personas/${id}`, { method: "DELETE", credentials: "include" });
    if (response.ok) return;
    if (response.status === 401) throw new Error(PERSONA_DELETE_MESSAGES.auth);
    const body = await response.json().catch(() => null);
    throw new Error(personaDeletionMessage(new Error(typeof body?.message === "string" ? body.message : "")));
  } catch (error) {
    throw new Error(personaDeletionMessage(error));
  }
}
